module.exports = __webpack_public_path__ + "static/img/zbmr.f8d37e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zbmr.png
// module id = w8ED
// module chunks = 1